/**
 * This is the main entry point of the Javascript.
 * It initializes the necessary components.
 */

import { setCookie, getCookie } from "./components/cookies";
import Sliders from "./components/Sliders";

document.addEventListener("DOMContentLoaded", () => {
	Sliders();
	const header = document.getElementsByClassName("header")[0];
	const body = document.getElementsByTagName("body")[0];
	const burger = document.getElementsByClassName("header__wrapper-right-burger")[0];
	const burgerMenu = document.getElementsByClassName("burger-menu")[0];
	const dropdowns = document.querySelectorAll(".dropdown-menu");
	const according = document.querySelectorAll(
		".according-with-image__wrapper-text-according-item-title"
	);
	const allAccordings = document.querySelectorAll(
		".according-with-image__wrapper-text-according-item"
	);
	const ourTeam = document.querySelectorAll(".our-team-info__wrapper-left-list-item");
	const ourTeamDescriptions = document.querySelectorAll(
		".our-team-info__wrapper-right-description-item"
	);
	const allIds = document.querySelectorAll('a[href^="#"]');
	const allInactiveMenuElements = document.querySelectorAll(".menu-item.inactive > a");
	const popup = document.getElementsByClassName("offert-popup")[0];
	const closePopup = document.getElementsByClassName(
		"offert-popup__wrapper-buttons-accept"
	)[0];

	if (closePopup) {
		closePopup.addEventListener("click", () => {
			popup.classList.remove("active");
		});
	}

	if (popup) {
		setTimeout(() => {
			popup.classList.add("active");
		}, 1000);
	}

	if (allInactiveMenuElements) {
		allInactiveMenuElements.forEach((anchor) => {
			anchor.addEventListener("click", function (e) {
				e.preventDefault();
			});
		});
	}

	if (allIds) {
		allIds.forEach((anchor) => {
			anchor.addEventListener("click", function (e) {
				e.preventDefault();

				const targetId = this.getAttribute("href").substring(1);
				const targetElement = document.getElementById(targetId);

				if (targetElement) {
					window.scrollTo({
						top: targetElement.offsetTop,
						behavior: "smooth",
					});
				}
			});
		});
	}

	if (ourTeam) {
		// Initialize active element on page load
		ourTeam.forEach((item) => {
			if (item.classList.contains("active")) {
				const description = item.querySelector(
					".our-team-info__wrapper-left-list-item-description"
				);
				if (description) {
					description.style.maxHeight = description.scrollHeight + "px";
				}
				const activeItemData = item.dataset.item;
				ourTeamDescriptions.forEach((descItem) => {
					if (descItem.dataset.item === activeItemData) {
						descItem.classList.add("active");
					}
				});
			}
		});

		// Event listener for click events
		ourTeam.forEach((item) => {
			item.addEventListener("click", (event) => {
				const isActive = item.classList.contains("active");

				// Remove active class from all items
				ourTeam.forEach((teamItem) => {
					teamItem.classList.remove("active");
					teamItem.querySelector(
						".our-team-info__wrapper-left-list-item-description"
					).style.maxHeight = "0";
				});

				// Toggle active class on the clicked item
				if (!isActive) {
					item.classList.add("active");
					const description = item.querySelector(
						".our-team-info__wrapper-left-list-item-description"
					);
					if (description) {
						description.style.maxHeight = description.scrollHeight + "px";
					}
				}

				// Log the dataset item
				console.log(event.currentTarget.dataset.item);

				// Remove active class from all descriptions
				if (ourTeamDescriptions) {
					ourTeamDescriptions.forEach((descItem) => {
						descItem.classList.remove("active");

						// Add active class to the matched description item
						if (
							!isActive &&
							event.currentTarget.dataset.item === descItem.dataset.item
						) {
							descItem.classList.add("active");
						}
					});
				}
			});
		});
	}

	if (according) {
		according.forEach((item) => {
			item.addEventListener("click", () => {
				const parent = item.parentElement;
				const description = parent.querySelector(".description");
				const isOpen = parent.classList.contains("active");

				if (allAccordings) {
					allAccordings.forEach((i) => {
						if (i.classList.contains("active")) {
							i.classList.remove("active");
							const desc = i.querySelector(".description");
							desc.style.height = null;
						}
					});
				}

				if (!isOpen) {
					parent.classList.add("active");
					description.style.height = description.scrollHeight + "px";
				} else {
					parent.classList.remove("active");
					description.style.height = null;
				}
			});
		});
	}

	if (burger) {
		burger.addEventListener("click", function () {
			if (burgerMenu) {
				if (burgerMenu.classList.contains("active")) {
					burgerMenu.classList.remove("active");
					this.classList.remove("active");
				} else {
					burgerMenu.classList.add("active");
					this.classList.add("active");
				}
			}
		});
	}

	if (header) {
		window.addEventListener("scroll", function () {
			if (window.scrollY > 100) {
				header.classList.add("scrolled");
				body.classList.add("scrolled");
			} else {
				header.classList.remove("scrolled");
				body.classList.remove("scrolled");
			}
		});
	}

	if (dropdowns) {
		dropdowns.forEach((dropdown) => {
			dropdown.addEventListener("click", function (event) {
				event.preventDefault();
				const parentLi = this.closest("li");
				const submenu = parentLi.querySelector(".sub-menu");

				if (submenu.classList.contains("open")) {
					submenu.classList.remove("open");
					parentLi.classList.remove("active");
					submenu.style.maxHeight = "0";
					this.classList.remove("active");
				} else {
					// Zamknięcie innych otwartych podmenu (opcjonalnie)
					document.querySelectorAll(".sub-menu.open").forEach((openSubmenu) => {
						openSubmenu.classList.remove("open");
						openSubmenu.style.maxHeight = "0";
						openSubmenu
							.closest("li")
							.querySelector(".dropdown-menu")
							.classList.remove("active");
					});

					submenu.classList.add("open");
					parentLi.classList.add("active");
					submenu.style.maxHeight = submenu.scrollHeight + "px";
					this.classList.add("active");
				}
			});
		});
	}
});
